import { Button, PageHeader } from 'components';
import { Form, Row, Col, Spin } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined, EyeOutlined } from '@ant-design/icons';
import InfoSection from './formSections/info';
import { useTranslation } from 'react-i18next';
import useEmergencyContacts from '../useEmergencyContacts';
import FormHelper from '../../../../../helpers/FormHelper';
import { Link, useLocation } from 'react-router-dom';
import UIHelper from '../../../../../helpers/UIHelper';

const Edit = ({ isNew }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { form, shops, inactiveShops, updateInProcess, handleCreateOrUpdate } =
    useEmergencyContacts(false, !isNew);
  const onFinish = async (values) => {
    await handleCreateOrUpdate(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  const title = isNew
    ? t('CONTATTI DI EMERGENZA')
    : t('MODIFICA CONTATTI DI EMERGENZA');

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Spin spinning={updateInProcess}>
          <Form
            form={form}
            name='basic'
            wrapperCol={{
              span: 24,
            }}
            initialValues={{
              role: '',
              name: '',
              surname: '',
              phone: '',
              company_id: '',
              priority: '',
            }}
            layout={'vertical'}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete='off'
            onFieldsChange={FormHelper.resetFormsFieldErrors(form)}
          >
            <InfoSection shops={shops} inactiveShops={inactiveShops} />
          </Form>
          <Row gutter={16}>
            <Col>
              <Button
                onClick={onClickSave}
                width={'150px'}
                big
                icon={<CheckOutlined />}
                loading={updateInProcess}
              >
                {t('Invia')}
              </Button>
            </Col>
          </Row>
        </Spin>
      </div>
    </div>
  );
};

export default Edit;
